export enum APPLY {
  STEP_PROGRESS_BAR = "applyStepProgressBar",
  APPLY_NOW_BTN = "applyNowBtn",
}

export enum START {
  EMAIL = "applyStartEmailAddress",
  EMAIL_ERROR = "applyStartEmailAddressError",
  TOS_CHECKBOX = "applyStartTermsOfUseCheckbox",
  TOS_LABEL = "applyStartTermsOfUseLabel",
  TOS_REQUIRED_ERROR = "applyStartTermsOfUseRequiredError",
  NEXT_STEP = "applyStartNextStepButton",
}

export enum PERSONAL_INFORMATION {
  TITLE = "personalTitle",
  FIRST_NAME = "personalFirstName",
  FIRST_NAME_ERROR = "personalFirstNameError",
  LAST_NAME = "personalLastName",
  LAST_NAME_ERROR = "personalLastNameError",
  PHONE_NUMBER_PREFIX = "personalPhoneNumberPrefix",
  PHONE_NUMBER = "personalPhoneNumber",
  PHONE_NUMBER_ERROR = "personalPhoneNumberError",
  STREET_ADDRESS = "personalStreetAddress",
  STREET_ADDRESS_ERROR = "personalStreetAddressError",
  POST_CODE = "personalPostCode",
  POST_CODE_ERROR = "personalPostCodeError",
  CITY = "personalCity",
  CITY_ERROR = "personalCityError",
  NEXT_STEP = "personalNextStepButton",
}

export enum EXPERIENCE_INFORMATION {
  PERMIT_TYPES_HEADING = "experiencePermitTypesHeading",
  HOURS_PER_WEEK_HEADING = "experienceHoursPerWeekHeading",
  EXPERIENCE_YEARS_HEADING = "experienceExperienceYearsHeading",
  EXPERIENCE_SOURCE_HEADING = "experienceExperienceSourceHeading",
  CAR_FOR_WORK_HEADING = "experienceCarForWorkHeading",
  UPLOAD_RESUME_HEADING = "experienceUploadResumeHeading",
  HOW_DID_YOU_HEAR_HEADING = "experienceHowDidYouHearHeading",
  PERMIT_TYPE_ERROR = "experiencePermitTypeError",
  HOURS_PER_WEEK_ERROR = "experienceHoursPerWeekError",
  EXPERIENCE_YEARS_ERROR = "experienceExperienceYearsError",
  EXPERIENCE_SOURCE_ERROR = "experienceExperienceSourceError",
  CAR_FOR_WORK_ERROR = "experienceCarForWorkError",
  UPLOAD_RESUME = "experienceUploadResumeButton",
  UPLOAD_RESUME_ERROR = "experienceUploadResumeError",
  SUBMIT = "experienceSubmitButton",
  SUBMIT_ERROR = "experienceSubmitError",
  INFO_SOURCE_ERROR = "experienceInfoSourceError",
}

export enum UPLOAD_RESUME {
  FILE_ITEM = "uploadResumeFileItem",
  FILE_ICON = "uploadResumeFileIcon",
  FILE_NAME = "uploadResumeFileName",
  FILE_SIZE = "uploadResumeFileSize",
  DELETE_FILE = "uploadResumeDeleteFileIcon",
}

export enum THANK_YOU_PAGE {
  PICTURE = "thankYouPicture",
  QUOTE = "thankYouQuote",
  QUOTE_AUTHOR = "thankYouQuoteAuthor",
  SUCCESS_HEADING = "thankYouSuccessHeading",
  CONFIRMATION_EMAIL = "thankYouEmailParagraph",
  CONTACT_APPLICANT = "thankYouContactApplicantParagraph",
  CONTACT_US = "thankYouContactUsParagraph",
  SOCIAL_SHARE = "thankYouSocialShare",
}
